import React from 'react';
import PackageDropdownContainer from '../../../fulfillment-planner/package/dropdown/container';
import PackageLabel from '../../../fulfillment-planner/package/label';

import style from './style.module.less';

const Package = () => {
  return (
    <React.Fragment>
      <div className={style.label}>
        <PackageLabel />
      </div>
      <PackageDropdownContainer />
      <div />
    </React.Fragment>
  );
};

export default Package;
